export const sources={webp:"__VITE_ASSET__DZNi6gKJ__ 30w"};export const img={src:"__VITE_ASSET__QdgCqoph__",w:30,h:30};export default{sources:sources,img:img};